export default __webpack_public_path__ + "static/hubspot-form-generator-overview-43ae8baf7048cef01847d7ceb34eb8d0.mp4";